import { render, staticRenderFns } from "./PostOutcome.vue?vue&type=template&id=4c6f9b75&scoped=true&"
import script from "./PostOutcome.vue?vue&type=script&lang=js&"
export * from "./PostOutcome.vue?vue&type=script&lang=js&"
import style0 from "./PostOutcome.vue?vue&type=style&index=0&id=4c6f9b75&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6f9b75",
  null
  
)

export default component.exports